<template>
    <div>
        <v-list class="px-3"  style="max-width: 300px;">
            <v-list-item>
                <v-list-item-title style="font-weight: bold;"> {{ $t('yego_dashboard.settings') }} </v-list-item-title>
            </v-list-item>
            
            <v-list-item>
                <v-list-item-title>{{ $t('yego_dashboard.show_options') }}</v-list-item-title>
            </v-list-item>
            
            <v-list-item class="my-1">
                <v-radio-group v-model="days_in_transit_options.result_type">
                    <v-radio class="px-1" v-for="t of days_in_transit_options.result_types" color="blue_accent" :key="t" :label="$t('yego_dashboard.result_types_' + t)" :value="t"></v-radio>
                </v-radio-group>
            </v-list-item>

            <v-list-item class="mt-6">
                <v-row justify="center" align="center">
                    <v-col cols="12" justify="center" align="center">
                        <v-btn color="secondary" small outlined style="min-width: 100%;" @click="emitValue()">{{ $t('yego_dashboard.update_options') }}</v-btn>
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>

export default {
    props: [
        'days_in_transit_options'
    ],
    data(){
        return {}
    },
    mounted(){
    },
    methods: {
        emitValue() {
            this.$emit('days_in_transit_options', this.days_in_transit_options);
        }
    },
    watch: {}
}
</script>

<style>

</style>